import styles from './style.module.css';
import ModelUploader from '../../compoenets/ModelUploader';

export default function ModelUpload(){
  
  return(
    <div className={styles['wrap']}>
        <ModelUploader mode='win'/>
    </div>
  )
}